export type NavItem = {
  id: string;
  label: string;
};

export const NAV_ITEMS: NavItem[] = [
  { id: 'projects',      label: 'Projects' },
  { id: 'visual-editor', label: 'Visual Editor' },
  { id: 'json-editor',   label: 'JSON Editor' },
  { id: 'preview',       label: 'Preview' },
  { id: 'inspector',     label: 'Actions & Bindings' },
  { id: 'history',       label: 'Execution History' },
  { id: 'publishing',    label: 'Publishing' },
  { id: 'users',         label: 'Users' },
];
